<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.interfaces.pageGenericPos.title') }}
    </portal>
    <template v-if="config !== null">
      <card :title="$t('admin.interfaces.pageGenericPos.card.general')" cols="12 6@desktop">
        <!--        <card-badge :tooltip="$t('betaVersion.tooltip')">{{ $t('betaVersion.title') }}</card-badge>-->
        <hm-card-inner>
          <hm-input-select :label="$t('admin.interfaces.pageGenericPos.posSystem')"
                           :value="posSystem"
                           :disabled="!hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           name="posSystem"
                           @input="onChangePosSystem"
                           @change="onChangePosSystem">
            <option v-for="it in posSystems" :value="it" v-html="it.name" />
          </hm-input-select>
          <template>
            <hm-input v-if="!isNil(pendingPosSystem) && hasRole('ROLE_SYSADMIN')"
                      :label="`${$t('admin.interfaces.pageGenericPos.companyCode')} 🔒`"
                      :placeholder="$t('admin.interfaces.pageGenericPos.enterCompanyCode')"
                      v-model="config.companyCode"
                      cols="12 6@hd start-1"
                      name="companyCode" />
            <hm-input v-else-if="!isNil(posSystem) && posSystem.protectCompanyCode"
                      :label="`${$t('admin.interfaces.pageGenericPos.companyCode')} 🔒`"
                      :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN')"
                      :value="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') ? config.companyCode : config.companyCode.replace(/.(?=.{4,}$)/g, '*')"
                      cols="12 6@hd start-1"
                      name="companyCode" />
            <hm-input v-else-if="hasRole('ROLE_SYSADMIN')"
                      :label="`${$t('admin.interfaces.pageGenericPos.companyCode')} 🔒`"
                      v-model="config.companyCode"
                      cols="12 6@hd start-1"
                      name="companyCode" />
            <hm-input v-else
                      :disabled="true"
                      :label="`${$t('admin.interfaces.pageGenericPos.companyCode')} 🔒`"
                      :value="hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') ? config.companyCode : config.companyCode.replace(/.(?=.{4,}$)/g, '*')"
                      cols="12 6@hd start-1"
                      name="companyCode" />
          </template>
          <hm-textarea :label="$t('admin.interfaces.pageGenericPos.allowedIpAddresses')"
                       :help="$t('admin.interfaces.pageGenericPos.allowedIpAddressesHelp')"
                       v-model="allowedIpAddressesText"
                       :disabled="!hasRole('ROLE_SYSADMIN')"
                       :input-rows="3"
                       cols="12 6@hd start-1"
                       name="allowedIpAddresses" />
          <hm-input :label="$t('admin.interfaces.pageGenericPos.label')"
                    v-model="config.label"
                    :disabled="disabledFields.includes('label')"
                    cols="12 6@hd start-1"
                    name="label" />
        </hm-card-inner>
        <hm-card-inner>
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.enabled')"
                           :enabled-title="$t('enabled')"
                           :disabled-title="$t('disabled')"
                           v-model="config.enabled"
                           cols="12 6@hd start-1"
                           name="enabled" />
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.postItemsIndividually')"
                           v-model="config.postItemsIndividually"
                           :disabled="disabledFields.includes('postItemsIndividually') || !hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           name="postItemsIndividually" />
          <!-- required for Steingress -->
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.useGuestId')"
                           v-model="config.useGuestId"
                           :disabled="disabledFields.includes('useGuestId') || !hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           name="useGuestId" />
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.hideDescription')"
                           v-model="config.hideDescription"
                           :disabled="disabledFields.includes('hideDescription')"
                           cols="12 6@hd start-1"
                           name="hideDescription" />
          <!-- required for Melzer -->
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.useNumericGuestId')"
                           v-model="config.useNumericGuestId"
                           :disabled="disabledFields.includes('useNumericGuestId') || !hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           name="useNumericGuestId" />
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.provideFolios')"
                           v-model="config.provideFolios"
                           :disabled="disabledFields.includes('provideFolios') || !hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           name="provideFolios" />
          <!-- may not be disabled for APRO, Steingress, Melzer -->
          <hm-input-toggle :label="$t('admin.interfaces.pageGenericPos.cacheDisabled')"
                           :disabled="!hasRole('ROLE_HOTELMEISTER_SUPER_ADMIN') || ['apro', 'Steingress', 'MelzerX3000', 'rainmaker'].includes((posSystem || {}).name)"
                           v-model="config.cacheDisabled"
                           cols="12 6@hd start-1"
                           name="cacheDisabled" />
        </hm-card-inner>
      </card>
      <card :title="$t('admin.interfaces.pageGenericPos.categoryMapping.mapping')" cols="12 6@desktop">
        <hm-card-inner>
          <hm-input-select :label="$t('admin.interfaces.pageGenericPos.mappingType')"
                           v-model="config.mappingType"
                           :disabled="disabledFields.includes('mappingType') || !hasRole('ROLE_SYSADMIN')"
                           cols="12 6@hd start-1"
                           enum-name="PosMappingType"
                           name="mappingType" />
          <hm-input-select v-if="config.mappingType === 'Invoice'"
                           :label="$t('admin.interfaces.pageGenericPos.invoiceIhsId')"
                           v-model="config.invoiceIhsId"
                           :disabled="disabledFields.includes('invoiceIhsId')"
                           cols="12 6@hd start-1"
                           name="invoiceIhsId">
            <option :value="null"></option>
            <option v-for="item in hotelSettings.inHouseServices.all(config.invoiceIhsId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
          <hm-input-select :label="$t('admin.interfaces.pageGenericPos.tipIhsId')"
                           v-model="config.tipIhsId"
                           :disabled="disabledFields.includes('tipIhsId')"
                           cols="12 6@hd start-1"
                           name="tipIhsId">
            <option :value="null"></option>
            <option v-for="item in hotelSettings.inHouseServices.all(config.tipIhsId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
          </hm-input-select>
        </hm-card-inner>
        <hm-card-inner v-if="config.mappingType === 'VatRate'" :full-size="true">
          <hm-table :hover="false"
                    min-width="400px"
                    columns="2"
                    grid-template-columns="1fr 2fr">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.vatMapping.vat') }}</div>
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.vatMapping.ihs') }}</div>
            </template>
            <template v-for="(vat, vatIdx) in config.vatRateToIhsId">
              <div class="hm-table__td">
                <hm-input-money :label="$t('admin.interfaces.pageGenericPos.vatMapping.vat')"
                                :digits="2"
                                :inline="true"
                                v-model="vat.key"
                                :id="`vat-${vatIdx}`"
                                currency="%"
                                name="vat" />
              </div>
              <div class="hm-table__td">
                <hm-input-select :label="$t('admin.interfaces.pageGenericPos.vatMapping.ihs')"
                                 :inline="true"
                                 v-model="vat.value"
                                 :id="`ihs-${vatIdx}`"
                                 name="ihs">
                  <option :value="null"></option>
                  <option v-for="item in hotelSettings.inHouseServices.all(vat.value)" :value="item.id" v-html="item.name[$shortLocale]"></option>
                </hm-input-select>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
        <hm-card-inner v-if="config.mappingType === 'CategoryId'">
          <hm-table :hover="false"
                    min-width="400px"
                    columns="2"
                    grid-template-columns="1fr 2fr">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.categoryMapping.category') }}</div>
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.categoryMapping.ihs') }}</div>
            </template>
            <template v-for="(category, categoryIdx) in config.categoryIdToIhsId">
              <div class="hm-table__td">
                <hm-input :label="$t('admin.interfaces.pageGenericPos.categoryMapping.category')"
                          :inline="true"
                          v-model="category.key"
                          :id="`category-${categoryIdx}`"
                          name="category" />
              </div>
              <div class="hm-table__td">
                <hm-input-select :label="$t('admin.interfaces.pageGenericPos.categoryMapping.ihs')"
                                 :inline="true"
                                 v-model="category.value"
                                 :id="`ihs-${categoryIdx}`"
                                 name="ihs">
                  <option :value="null"></option>
                  <option v-for="item in hotelSettings.inHouseServices.all(category.value)" :value="item.id" v-html="item.name[$shortLocale]"></option>
                </hm-input-select>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
      </card>
      <card :title="$t('admin.interfaces.pageGenericPos.categoryMapping.fakeReservations')" cols="12 6@desktop">
        <hm-card-inner>
          <hm-table :hover="false"
                    :disable-scroll="true"
                    columns="2"
                    grid-template-columns="1fr 2fr">
            <template slot="table-head">
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.fakeReservations.roomNumber') }}</div>
              <div class="hm-table__th">{{ $t('admin.interfaces.pageGenericPos.fakeReservations.guestProfileId') }}</div>
            </template>
            <template v-for="(fakeReservation, fakeReservationIdx) in config.fakeReservationList">
              <div class="hm-table__td">
                <hm-input :label="$t('admin.interfaces.pageGenericPos.fakeReservations.roomNumber')"
                          :inline="true"
                          v-model="fakeReservation.roomNumber"
                          :id="`roomNumber-${fakeReservationIdx}`"
                          name="roomNumber" />
              </div>
              <div class="hm-table__td hm-table__td--overflow">
                <guest-search v-model="fakeReservation.guestProfileId"
                              :label="$t('admin.interfaces.pageGenericPos.fakeReservations.guestProfileId')"/>
              </div>
            </template>
          </hm-table>
        </hm-card-inner>
      </card>
    </template>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import Card from '../../../lib/layout/Card';
import HmInputCheckbox from '../../../lib/inputs/HmInputCheckbox';
import HmInputMoney from '../../../lib/inputs/HmInputMoney';
import HmCardInner from '../../../lib/layout/HmCardInner';
import HmTextarea from '../../../lib/inputs/HmTextarea';
import HmTable from '../../../lib/table/HmTable';
import { cloneDeep, isEmpty, isNil, last, sortBy } from 'lodash';
import HmInputSelect from '../../../lib/inputs/HmInputSelect';
import GuestSearch from '../../../lib/inputs/GuestSearch';

export default {
  name: 'PageGenericPos',
  components: { GuestSearch, HmInputSelect, HmTable, HmTextarea, HmCardInner, HmInputMoney, HmInputCheckbox, Card },
  mixins: [HotelmeisterMixin, SaveWatchMixin],

  autosave: [
    {
      name: 'config',
      variable: 'config',
      fn: function (cbSaveComplete) {
        cbSaveComplete();

        const toSave = cloneDeep(this.config);
        toSave.vatRateToIhsId = Object.fromEntries(toSave.vatRateToIhsId.filter(it => !isNil(it.key) && !isEmpty(it.value)).map(it => [it.key, it.value]));
        toSave.categoryIdToIhsId = Object.fromEntries(toSave.categoryIdToIhsId.filter(it => !isEmpty(it.key) && !isEmpty(it.value)).map(it => [it.key, it.value]));
        toSave.fakeReservationList = toSave.fakeReservationList.filter(it => !isEmpty(it.roomNumber));

        this.axios.put(this.serviceUrls.interfaces.genericPos.get(this), toSave)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
          })
          .catch((error) => {
            if (isNil(error.response)) this.showErrorMessage();
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  data() {
    return {
      config: null,
      posSystem: null,
      // a chosen POS system whose company code is not entered yet - the page only knows hashes of the codes
      pendingPosSystem: null,
      posSystems: {
        userDefined: {
          name: this.$t('admin.interfaces.pageGenericPos.categoryMapping.userDefined'),
          data: {
          },
          companyCodeHashes: [],
        },
        Adelsberger: {
          name: 'Adelsberger',
          data: {
            cacheDisabled: false,
          },
          companyCodeHashes: ['d31a019a083a4c9e1399c4701f182a9d8362a05c3595e3da06a05e1e962aadde'],
          protectCompanyCode: true,
        },
        apro: {
          name: 'apro Kassensystem',
          data: {
            cacheDisabled: false,
          },
          companyCodeHashes: ['8c662de58aa20e13758944aa00d5f0723a331c59f276b9033781f3231ff0d883'],
          protectCompanyCode: true,
        },
        gastroAssistent: {
          name: 'gastroAssistent',
          data: {
            cacheDisabled: false,
            provideFolios: false,
            useNumericGuestId: false,
          },
          companyCodeHashes: ['d8634f361e08f1af29cbb7932dd87be9d00d8b91df21456c05b31fca35a805c9'],
          protectCompanyCode: true,
        },
        hiopos: {
          name: 'HIOPOS',
          data: {
          },
          companyCodeHashes: ['b8fe981f38afeac8e247bc460bfa32d29c59c81f56b17525f884ae8ad6032466'],
          protectCompanyCode: true,
        },
        MelzerX3000: {
          name: 'Melzer X3000',
          data: {
            cacheDisabled: false,
            provideFolios: false,
            useNumericGuestId: true,
          },
          companyCodeHashes: ['cf52583fd392e4e94839ec9ccdfd66a2d2d2af67b244dae83dc80b67f47848fe'],
          protectCompanyCode: true,
        },
        rsPos: {
          name: '[rs]Pos',
          data: {
            postItemsIndividually: true,
            provideFolios: false,
            useNumericGuestId: false,
            cacheDisabled: true,
          },
          companyCodeHashes: ['05d6b2c537c8dcd56ca969a9bb5cee9d8e2f3ef658f5f125bce10f9d0061ca60'],
          protectCompanyCode: true,
        },
        Steingress: {
          name: 'Steingress Kassensysteme',
          data: {
            postItemsIndividually: true,
            cacheDisabled: false,
            provideFolios: false,
            useNumericGuestId: false,
          },
          companyCodeHashes: ['c74a3793b1117e42471fa663b174e194e96296427a5016619e5ee987bf80a550', '60cdbdcc31cc650290f1273d3c1f3faac9f129bc899e086019e9a1ffe03349a0'],
          protectCompanyCode: true,
        },
        Gastrotouch: {
          name: 'Gastrotouch',
          data: {
            postItemsIndividually: true,
            cacheDisabled: false,
            provideFolios: false,
            useNumericGuestId: true,
          },
          companyCodeHashes: ['c19d3121e83c888cf6e7f1db0818deb4f844508cff9416a3c3c47ff436faf816'],
          protectCompanyCode: true,
        },
        woetzer: {
          name: 'Computerkassen Wötzer',
          data: {
            cacheDisabled: false,
          },
          companyCodeHashes: ['e5118b11442f713c3e519ae67351c4eca54a2066fa5887a51815798eb05c99a7'],
          protectCompanyCode: true,
        },
        fersterer: {
          name: 'rainmaker',
          data: {
            postItemsIndividually: true,
            cacheDisabled: false,
            provideFolios: false,
            useNumericGuestId: true,
          },
          companyCodeHashes: ['f2670cce0ca59cf60a6a7bfa8266c1b73ef2f8466a2fb7273d114364c5db825c'],
          protectCompanyCode: true,
        },
      },
    };
  },

  computed: {
    enums: function () {
      return this.$store.getters['enums/enums'];
    },
    // one address or CIDR range per line (or separated by commas) - empty allows every address
    allowedIpAddressesText: {
      get: function () {
        return (this.config.allowedIpAddresses || []).join('\n');
      },
      set: function (value) {
        this.config.allowedIpAddresses = (value || '').split(/[\s,;]+/).filter(it => !isEmpty(it));
      },
    },
    disabledFields: function () {
      if (isNil(this.posSystem) || isNil(this.posSystem.data)) return [];
      else return Object.keys(this.posSystem.data);
    },
  },

  watch: {
    'config.vatRateToIhsId': {
      handler: function (newVal) {
        let ret = cloneDeep(newVal);

        const emptyRecords = ret.filter(it => isNil(it.key) && isEmpty(it.value)).length;
        const lastRecord = last(ret);

        if (emptyRecords > 1 || isNil(lastRecord) || !isNil(lastRecord.key) || !isEmpty(lastRecord.value)) {
          ret = ret.filter(it => !isNil(it.key) || !isEmpty(it.value));
          ret.push({ key: null, value: null });

          this.config.vatRateToIhsId = ret;
        } else if (emptyRecords === 0) {
          ret.push({ key: null, value: null });

          this.config.vatRateToIhsId = ret;
        }
      },
      deep: true,
    },
    'config.categoryIdToIhsId': {
      handler: function (newVal) {
        let ret = cloneDeep(newVal);

        const emptyRecords = ret.filter(it => isEmpty(it.key) && isEmpty(it.value)).length;
        const lastRecord = last(ret);

        if (emptyRecords > 1 || isNil(lastRecord) || !isEmpty(lastRecord.key) || !isEmpty(lastRecord.value)) {
          ret = ret.filter(it => !isEmpty(it.key) || !isEmpty(it.value));
          ret.push({ key: null, value: null });

          this.config.categoryIdToIhsId = ret;
        } else if (emptyRecords === 0) {
          ret.push({ key: null, value: null });

          this.config.categoryIdToIhsId = ret;
        }
      },
      deep: true,
    },
    'config.fakeReservationList': {
      handler: function (newVal) {
        let ret = cloneDeep(newVal);

        const emptyRecords = ret.filter(it => isEmpty(it.roomNumber) && isEmpty(it.guestProfileId)).length;
        const lastRecord = last(ret);

        if (emptyRecords > 1 || isNil(lastRecord) || !isEmpty(lastRecord.roomNumber) || !isEmpty(lastRecord.guestProfileId)) {
          ret = ret.filter(it => !isEmpty(it.roomNumber) || !isEmpty(it.guestProfileId));
          ret.push({ fakeNumber: null, roomNumber: null, guestProfileId: null });

          this.config.fakeReservationList = ret;
        } else if (emptyRecords === 0) {
          ret.push({ fakeNumber: null, roomNumber: null, guestProfileId: null });

          this.config.fakeReservationList = ret;
        }
      },
      deep: true,
    },
    'config.companyCode': {
      handler: async function (newVal) {
        const posSystem = await this.findPosSystem(newVal);
        // the code changed again while hashing
        if (isNil(this.config) || this.config.companyCode !== newVal) return;

        if (!isNil(posSystem)) {
          Object.entries(posSystem.data).forEach((it) => {
            this.config[it[0]] = it[1];
          });
          this.pendingPosSystem = null;
          this.posSystem = posSystem;
        } else {
          this.posSystem = isNil(this.pendingPosSystem) ? this.posSystems.userDefined : this.pendingPosSystem;
        }
      },
      deep: true,
    },
  },

  created: function () {
    this.posSystem = this.posSystems.userDefined;
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.interfaces.genericPos.get(this))
        .then((response) => {
          const tmp = response.data.data;
          if (!isNil(tmp.vatRateToIhsId)) tmp.vatRateToIhsId = sortBy(Object.entries(tmp.vatRateToIhsId).map(it => ({ key: parseFloat(it[0]), value: it[1] })), 'key');
          if (isNil(tmp.allowedIpAddresses)) tmp.allowedIpAddresses = [];
          if (!isNil(tmp.categoryIdToIhsId)) tmp.categoryIdToIhsId = sortBy(Object.entries(tmp.categoryIdToIhsId).map(it => ({ key: it[0], value: it[1] })), 'key');

          this.config = tmp;
        });
    },
    async onChangePosSystem(posSystem) {
      if (isNil(posSystem)) {
        this.companyCode = null;
        this.pendingPosSystem = null;
        this.posSystem = this.posSystems.userDefined;
        return;
      }

      Object.entries(posSystem.data).forEach((it) => {
        this.config[it[0]] = it[1];
      });
      this.posSystem = posSystem;

      // the codes are not in the page any more - a POS system whose code is not set yet needs it typed in;
      // the code of the previous one is cleared, as before, so a protected code is never shown
      const current = await this.findPosSystem(this.config.companyCode);
      if (current === posSystem) {
        this.pendingPosSystem = null;
        return;
      }
      this.pendingPosSystem = isEmpty(posSystem.companyCodeHashes) ? null : posSystem;
      this.config.companyCode = null;
    },
    async findPosSystem(companyCode) {
      if (isEmpty(companyCode) || isNil(window.crypto) || isNil(window.crypto.subtle)) return null;

      const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(companyCode));
      const hash = Array.from(new Uint8Array(digest)).map(it => it.toString(16).padStart(2, '0')).join('');

      return Object.values(this.posSystems)
        .find(it => it.companyCodeHashes && it.companyCodeHashes.includes(hash)) || null;
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/interfaces/PageGenericPos.vue